export { SmartPhoneIcon } from './smart-phone'
